import React, { useEffect, useState } from "react";
import { Grid, Button } from "@mui/material";

const colorMap = {
  Yellow: "#e0b749",
  Orange: "#dd7505",
  Purple: "#5a3577",
  Pink: "#D380A7",
  Blue: "#0492c2",
  Brown: "#8B4513",
  Green: "#7fa04d",
  "Blue Green": "#13495f",
  "Greenish Blue": "#119DA4",
  "Brown Green": "#7A8450",
  Parti: "linear-gradient(90deg, #133874, #D1698B)",
};

const buttonBaseStyles = {
  maxWidth: "100px",
  textTransform: "none",
  boxShadow: "none",
  whiteSpace: "nowrap",
  fontWeight: 500,
  "&:hover": {
    boxShadow: "none",
  },
};

function getButtonStyles({ isSelected, gemstoneColor }) {
  const isGradient = gemstoneColor.startsWith("linear-gradient");
  return {
    ...buttonBaseStyles,
    ...(isGradient
      ? {
          backgroundColor: gemstoneColor,
          color: "#fff",
          borderColor: gemstoneColor,
        }
      : {
          backgroundColor: gemstoneColor,
          color: isSelected ? "black" : "#fff",
          border: isSelected ? "1px solid black" : "1px solid gray",
        }),
    fontWeight: isSelected ? 700 : 500,
    "&:hover": isGradient
      ? {
          backgroundColor: gemstoneColor + "22",
          color: "#fff",
        }
      : {
          backgroundColor: gemstoneColor + "22",
          color: gemstoneColor,
        },
  };
}

export const GemstoneColors = ({ filter, searchQuery, dispatch }) => {
  const colors = filter.values || [];
  const [selectedColors, setSelectedColors] = useState([]);

  function handleOnClick(filterName, valueName) {
    let newFields = searchQuery.fields.map((field) => ({
      ...field,
      values: [...field.values],
    }));

    const searchFieldIndex = newFields.findIndex(
      (field) => field.name === filterName
    );
    if (searchFieldIndex > -1) {
      const searchField = newFields[searchFieldIndex];
      const valueFound = searchField.values.find(
        (value) => value.name === valueName
      );

      if (valueFound) {
        searchField.values = searchField.values.filter(
          (value) => value.name !== valueName
        );

        if (searchField.values.length === 0) {
          newFields = newFields.filter((field) => field.name !== filterName);
        } else {
          newFields[searchFieldIndex] = searchField;
        }
        dispatch({ type: "updateSearchQuery", payload: newFields });
      } else {
        searchField.values = [...searchField.values, { name: valueName }];
        newFields[searchFieldIndex] = searchField;
        dispatch({ type: "updateSearchQuery", payload: newFields });
      }
    } else {
      const newSearchFields = [
        ...newFields,
        { name: filterName, values: [{ name: valueName }] },
      ];
      dispatch({ type: "updateSearchQuery", payload: newSearchFields });
    }

    setSelectedColors((prev) =>
      prev.includes(valueName)
        ? prev.filter((name) => name !== valueName)
        : [...prev, valueName]
    );
  }

  function formatColorName(name) {
    return name.replace(/([a-z])([A-Z])/g, "$1 $2");
  }

  useEffect(() => {
    if (searchQuery) {
      const colorField = searchQuery.fields.find(
        (field) => field.name === "Color"
      );
      const colorNames = colorField
        ? colorField.values.map((value) => value.name)
        : [];
      setSelectedColors(colorNames);
    }
  }, [searchQuery]);

  return (
    <Grid container marginBottom="1rem">
      {colors.map((color) => {
        const colorName = color.name;
        const isSelected = selectedColors.includes(colorName);
        const gemstoneColor = colorMap[colorName] || "#bbb";

        return (
          <Grid item xs="auto" key={colorName}>
            <Button
              onClick={() => handleOnClick("Color", colorName)}
              variant="contained"
              sx={getButtonStyles({ isSelected, gemstoneColor })}
              value={colorName}
            >
              {formatColorName(colorName)}
            </Button>
          </Grid>
        );
      })}
    </Grid>
  );
};
